<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="typeSelected"
            :options="types"
            :defaultSelected="defaultSelected ? {id: defaultSelected.enumName} : types[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import {mapGetters} from 'vuex';

    export default {
        name: "CarTypeDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            this.setTypes();
        },
        data() {
            return {
                types: []
            }
        },
        methods: {
            typeSelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
                    currentValueId: value.currentValue.id,
                    oldValue: value.oldValue
                });
            },
            setTypes() {
                this.types = [];
                this.types.push({
                    id: 'none',
                    name: '(всички)'
                });
                if (this.carTypes && Array.isArray(this.carTypes)) {
                    this.carTypes.forEach(type => {
                        type.id = type.enumName;
                        this.types.push(type)
                    });
                }
            }
        },
        computed: {
            ...mapGetters(['carTypes'])
        },
        watch: {
            carTypes: {
                handler() {
                    this.setTypes();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
